import { STAGE_COLORS, stageLabel } from "@/lib/lifecycle";

export const StageBadge = ({ stage, testId, label }) => (
  <span
    data-testid={testId || `stage-badge-${stage}`}
    className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-widest"
    style={{
      color: STAGE_COLORS[stage] || "#94a3b8",
      borderColor: `${STAGE_COLORS[stage] || "#94a3b8"}55`,
      backgroundColor: `${STAGE_COLORS[stage] || "#94a3b8"}14`,
    }}
  >
    <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: STAGE_COLORS[stage] || "#94a3b8" }} />
    {label || stageLabel(stage)}
  </span>
);
